import React from 'react';
import Icon from '~components/Icon';
import styles from './styles.module.css';

export type Option<T> = {
  value: T;
  label: string;
  icon?: string;
};

export type Props<T> = {
  options: Option<T>[];
  className?: string;
  value: T;
  onChange: (value: T) => void;
};

function ListingSwitch<T>({ options, className, value, onChange }: Props<T>) {
  const classes = [styles['listing-switch']];
  if (className) classes.push(className);

  return (
    <div className={classes.join(' ')}>
      <div className={styles['listing-switch__options']}>
        {options.map((item, index) => {
          const classes = [styles['listing-switch__option']];
          const isActive = value === item.value;

          if (isActive) classes.push(styles['listing-switch__option-active']);

          return (
            <div
              className={classes.join(' ')}
              onClick={() => onChange(item.value)}
              key={index}
            >
              {item.icon && (
                <Icon
                  icon={item.icon}
                  className={styles['listing-switch__icon']}
                />
              )}
              {item.label}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ListingSwitch;
